export function formatDate(timestamp: number, locale: string) {
  const dt = new Date(timestamp);
  const diffDays = new Date().getDate() - dt.getDate();
  const diffMonths = new Date().getMonth() - dt.getMonth();
  const diffYears = new Date().getFullYear() - dt.getFullYear();

  const timeString = new Date(timestamp).toLocaleTimeString(locale, {
    timeStyle: "short",
  });
  const dateString = new Date(timestamp).toLocaleDateString(locale, {
    dateStyle: "short",
  });

  if (diffYears === 0 && diffDays === 0 && diffMonths === 0) {
    return timeString;
  } else {
    return `${timeString}, ${dateString}`;
  }
}
